import { createInertiaApp, router } from '@inertiajs/svelte'
import  { mount } from 'svelte';
import Layout from '@layouts/layout.svelte'
import posthog from 'posthog-js'
import { hasCookieConsent } from '@lib/utils/cookie-consent'

const currentUrl = () => window.location.href

let lastCapturedUrl = null

posthog.init(import.meta.env.VITE_POSTHOG_PROJECT_TOKEN, {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  defaults: '2026-01-30',
  capture_pageview: false, // We manually capture pageviews on Inertia navigation
  opt_out_capturing_by_default: !hasCookieConsent(), // Require cookie consent before tracking
})

function syncPostHogIdentity(user) {
  if (!user) {
    posthog.reset()
    return
  }

  posthog.identify(user.email_address, {
    email: user.email_address,
    name: user.name,
    role: user.role,
    has_active_membership: user.has_active_membership,
  })
}

function capturePageview({ force = false } = {}) {
  const url = currentUrl()
  if (!force && url === lastCapturedUrl) return

  posthog.capture('$pageview', { $current_url: url })
  lastCapturedUrl = url
}

window.altruistCaptureCurrentPageview = capturePageview

router.on('navigate', (event) => {
  syncPostHogIdentity(event.detail.page.props.user)
  capturePageview()
})

createInertiaApp({
  // Disable progress bar
  //
  // see https://inertia-rails.dev/guide/progress-indicators
  // progress: false,
  // progress: {
  //   color: 'oklch(60% 0.118 184.704)' // Set a custom color for the progress bar
  // },

  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.svelte', {
      eager: true,
    })
    const page = pages[`../pages/${name}.svelte`]
    if (!page) {
      console.error(`Missing Inertia page component: '${name}.svelte'`)
    }

    // To use a default layout, import the Layout component
    // and use the following line.
    // see https://inertia-rails.dev/guide/pages#default-layouts
    //
    return { default: page.default, layout: page.layout || Layout }

    return page
  },

  setup({ el, App, props }) {
    if (el) {
      mount(App, { target: el, props })
      syncPostHogIdentity(props.initialPage.props.user)
      capturePageview()
    } else {
      console.error(
        "Missing root element.\n\n" +
        "If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n" +
        'Consider moving <%= vite_javascript_tag "inertia" %> to the Inertia-specific layout instead.',
      )
    }
  },

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
    },
    future: {
      useDataInertiaHeadAttribute: true,
      useDialogForErrorModal: true,
      preserveEqualProps: true,
    },
  },
})
